export { ArrowChevronLeft1 } from "./ArrowChevronLeft1";
